export default [
	{
		id: "pending",
		name: "resources.bookmaker-imports.fields.status.pending",
	},
	{
		id: "importing",
		name: "resources.bookmaker-imports.fields.status.importing",
	},
	{
		id: "imported",
		name: "resources.bookmaker-imports.fields.status.imported",
	},
	{
		id: "error",
		name: "resources.bookmaker-imports.fields.status.error",
	},
];
